import {ACTION_TYPE} from "utils/constants";

export const setCodeEditor = bool => ({
  type: ACTION_TYPE.SET_CODE_EDITOR,
  bool,
});

export const setCodeEditorMode = mode => ({
  type: ACTION_TYPE.SET_CODE_EDITOR_MODE,
  mode,
});

export const setCurrentScript = script => ({
  type: ACTION_TYPE.SET_CURRENT_SCRIPT,
  script,
});

export const showScriptList = bool => ({
  type: ACTION_TYPE.SHOW_SCRIPT_LIST,
  bool,
});
